import type {SelectedValueType} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';

export enum InputLabelHeaders {
  Subject,
  PreviewText,
  CampaignName,
}

export enum EmailWizardFlowType {
  Campaign = 'campaign',
  Template = 'template',
  Poster = 'poster',
}

export enum AiEmailSubjectOptionHeading {
  Tone = 'emailCampaignSubjectTone',
  Emojis = 'emojis',
  Purpose = 'purpose',
}

export enum AiEmailSubjectToneOption {
  Neutral = 'neutral',
  Professional = 'professional',
  Excited = 'excited',
  Confident = 'confident',
  Witty = 'witty',
  Empowering = 'empowering',
  Funny = 'funny',
}

export enum AiEmailSubjectEmojiOption {
  UseEmoji = 'use_emojis',
  NoEmoji = 'no_emojis',
}

export enum AiEmailSubjectPurposeOption {
  GenerateInterest = 'generate_interest',
  DriveAction = 'drive_action',
  AskQuestion = 'ask_a_question',
}

export interface EmailContentResponse {
  idEmailCampaignContent: number;
  iduser: number;
  content: string;
  prompt: string;
  options: string;
  generatedOn: string;
  contentType: string;
  contentGroupKey: string;
}

export interface SubjectAndPreviewText {
  subject: string;
  previewText: string;
  id?: string;
  configOptions?: SelectedValueType;
}

export interface RewriteEmailSubjectResponse {
  emailSubjects: SubjectAndPreviewText[];
}

export interface AiGeneratedEmailFieldsResponse extends SubjectAndPreviewText {
  campaignName: string;
}

export interface RandomizedLoadingMessage {
  campaignName: string;
  subject: string;
  previewText: string;
}
